/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnaliseIaControllerGerarDoGrupoParams,
  AnaliseIaControllerObterDoGrupoParams,
  AnaliseIaResponse,
  ErroResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAnaliseIaControllerObterDoGrupoUrl = (params: AnaliseIaControllerObterDoGrupoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/analises/ia/grupo?${stringifiedParams}` : `/v1/analises/ia/grupo`
}

/**
 * @summary A última análise por IA salva para o grupo. Não chama a IA.
 */
export const analiseIaControllerObterDoGrupo = async (params: AnaliseIaControllerObterDoGrupoParams, options?: Parameters<typeof httpClient>[1]): Promise<AnaliseIaResponse> => {

  return httpClient<AnaliseIaResponse>(getAnaliseIaControllerObterDoGrupoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAnaliseIaControllerObterDoGrupoQueryKey = (params?: AnaliseIaControllerObterDoGrupoParams,) => {
    return [
    `/v1/analises/ia/grupo`, ...(params ? [params] : [])
    ] as const;
    }


export const getAnaliseIaControllerObterDoGrupoQueryOptions = <TData = Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError = ErroResponse>(params: AnaliseIaControllerObterDoGrupoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnaliseIaControllerObterDoGrupoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>> = ({ signal }) => analiseIaControllerObterDoGrupo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AnaliseIaControllerObterDoGrupoQueryResult = NonNullable<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>>
export type AnaliseIaControllerObterDoGrupoQueryError = ErroResponse


export function useAnaliseIaControllerObterDoGrupo<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError = ErroResponse>(
 params: AnaliseIaControllerObterDoGrupoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>,
          TError,
          Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnaliseIaControllerObterDoGrupo<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError = ErroResponse>(
 params: AnaliseIaControllerObterDoGrupoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>,
          TError,
          Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnaliseIaControllerObterDoGrupo<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError = ErroResponse>(
 params: AnaliseIaControllerObterDoGrupoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A última análise por IA salva para o grupo. Não chama a IA.
 */

export function useAnaliseIaControllerObterDoGrupo<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError = ErroResponse>(
 params: AnaliseIaControllerObterDoGrupoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoGrupo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnaliseIaControllerObterDoGrupoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAnaliseIaControllerGerarDoGrupoUrl = (params: AnaliseIaControllerGerarDoGrupoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/analises/ia/grupo?${stringifiedParams}` : `/v1/analises/ia/grupo`
}

/**
 * @summary Gera (ou regera) a análise do grupo. Substitui a anterior — não acumula histórico.
 */
export const analiseIaControllerGerarDoGrupo = async (params: AnaliseIaControllerGerarDoGrupoParams, options?: Parameters<typeof httpClient>[1]): Promise<AnaliseIaResponse> => {

  return httpClient<AnaliseIaResponse>(getAnaliseIaControllerGerarDoGrupoUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAnaliseIaControllerGerarDoGrupoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analiseIaControllerGerarDoGrupo>>, TError,{params: AnaliseIaControllerGerarDoGrupoParams}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof analiseIaControllerGerarDoGrupo>>, TError,{params: AnaliseIaControllerGerarDoGrupoParams}, TContext> => {

const mutationKey = ['analiseIaControllerGerarDoGrupo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analiseIaControllerGerarDoGrupo>>, {params: AnaliseIaControllerGerarDoGrupoParams}> = (props) => {
          const {params} = props ?? {};

          return  analiseIaControllerGerarDoGrupo(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnaliseIaControllerGerarDoGrupoMutationResult = NonNullable<Awaited<ReturnType<typeof analiseIaControllerGerarDoGrupo>>>

    export type AnaliseIaControllerGerarDoGrupoMutationError = ErroResponse

    /**
 * @summary Gera (ou regera) a análise do grupo. Substitui a anterior — não acumula histórico.
 */
export const useAnaliseIaControllerGerarDoGrupo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analiseIaControllerGerarDoGrupo>>, TError,{params: AnaliseIaControllerGerarDoGrupoParams}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof analiseIaControllerGerarDoGrupo>>,
        TError,
        {params: AnaliseIaControllerGerarDoGrupoParams},
        TContext
      > => {
      return useMutation(getAnaliseIaControllerGerarDoGrupoMutationOptions(options), queryClient);
    }
    export const getAnaliseIaControllerObterDoExameUrl = (id: string,) => {




  return `/v1/analises/ia/exames/${id}`
}

/**
 * @summary A última análise por IA salva para o laudo. Não chama a IA.
 */
export const analiseIaControllerObterDoExame = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<AnaliseIaResponse> => {

  return httpClient<AnaliseIaResponse>(getAnaliseIaControllerObterDoExameUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAnaliseIaControllerObterDoExameQueryKey = (id: string,) => {
    return [
    `/v1/analises/ia/exames/${id}`
    ] as const;
    }


export const getAnaliseIaControllerObterDoExameQueryOptions = <TData = Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnaliseIaControllerObterDoExameQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>> = ({ signal }) => analiseIaControllerObterDoExame(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AnaliseIaControllerObterDoExameQueryResult = NonNullable<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>>
export type AnaliseIaControllerObterDoExameQueryError = ErroResponse


export function useAnaliseIaControllerObterDoExame<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>,
          TError,
          Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnaliseIaControllerObterDoExame<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>,
          TError,
          Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnaliseIaControllerObterDoExame<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A última análise por IA salva para o laudo. Não chama a IA.
 */

export function useAnaliseIaControllerObterDoExame<TData = Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analiseIaControllerObterDoExame>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnaliseIaControllerObterDoExameQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAnaliseIaControllerGerarDoExameUrl = (id: string,) => {




  return `/v1/analises/ia/exames/${id}`
}

/**
 * @summary Gera (ou regera) a análise do laudo, considerando o histórico do paciente.
 */
export const analiseIaControllerGerarDoExame = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<AnaliseIaResponse> => {

  return httpClient<AnaliseIaResponse>(getAnaliseIaControllerGerarDoExameUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAnaliseIaControllerGerarDoExameMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analiseIaControllerGerarDoExame>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof analiseIaControllerGerarDoExame>>, TError,{id: string}, TContext> => {

const mutationKey = ['analiseIaControllerGerarDoExame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analiseIaControllerGerarDoExame>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  analiseIaControllerGerarDoExame(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnaliseIaControllerGerarDoExameMutationResult = NonNullable<Awaited<ReturnType<typeof analiseIaControllerGerarDoExame>>>

    export type AnaliseIaControllerGerarDoExameMutationError = ErroResponse

    /**
 * @summary Gera (ou regera) a análise do laudo, considerando o histórico do paciente.
 */
export const useAnaliseIaControllerGerarDoExame = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analiseIaControllerGerarDoExame>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof analiseIaControllerGerarDoExame>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAnaliseIaControllerGerarDoExameMutationOptions(options), queryClient);
    }
